import { Upload, WithMongooseProps } from '@runelab/odin-common'

// Parsing lifecycle of a bot-chat attachment (server-side text extraction).
export enum ChatAttachmentStatusEnum {
  TRANSLATING = 'translating',
  READY = 'ready',
  FAILED = 'failed',
}

export type ChatAttachment = WithMongooseProps<{
  chatId: string
  tenantId?: string
  name: string
  uploadedFileId?: string
  // popolato dal server, con l'url gia firmato quando arriva dentro un messaggio
  uploadedFile?: Upload
  mimeType: string
  sizeBytes: number
  status: ChatAttachmentStatusEnum
}>
